import React, { FC, useEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import { Button, Col, Row } from 'antd'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { useUpdateEffect } from 'ahooks'

interface TagCheckBoxProps {
  dataList: any[]
  typeName: string // 类型名称
  setValue: (value: any) => void // 设置值
  fieldNames?: any // 字段名称
  value?: any //选中值
  disabled?: boolean
}

const TagCheckBox: FC<TagCheckBoxProps> = (props: TagCheckBoxProps) => {
  const { dataList = [], typeName, setValue, fieldNames, value, disabled } = props
  const [expanded, setExpanded] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const [showButton, setShowButton] = useState(false)
  const itemRef = useRef<any>(null)
  // useEffect(() => {
  if (fieldNames && fieldNames.label && fieldNames.value) {
    dataList?.forEach((item, index) => {
      item.title = item[fieldNames.label]
      item.value = item[fieldNames.value]
    })
  }
  useEffect(() => {
    if (!value) {
      setActiveIndex(0)
    } else {
      setActiveIndex(dataList.findIndex(item => item.value === value))
      // setValue(value)
    }
  }, [value, dataList])

  useEffect(() => {
    const checkOverflow = () => {
      if (itemRef.current && itemRef.current) {
        // 检查内容高度是否超过容器高度
        const isOverflowing = itemRef.current.scrollHeight > 32
        setShowButton(isOverflowing)
      }
    }

    checkOverflow()
    window.addEventListener('resize', checkOverflow)
    return () => {
      window.removeEventListener('resize', checkOverflow)
    }
  }, [dataList])
  return (
    <div className={styles.tagCheckBox}>
      <div className={styles.labelBox}>{typeName}：</div>
      <div
        className={styles.contentBox}
        ref={itemRef}
        style={{ height: !expanded ? '32px' : 'auto' }}
      >
        {dataList?.map((item, index) => {
          return (
            <div
              className={`${styles.tagItem}  
                  ${activeIndex === index ? styles.tagItemClick : ''}`}
              onClick={() => {
                setValue(item.value)
                setActiveIndex(index)
              }}
            >
              {item.title}
            </div>
          )
        })}
      </div>
      <div className={styles.expandBox} style={{}}>
        {showButton && (
          <div
            style={{
              cursor: 'pointer',
              fontSize: '14px',
              color: '#2D2D2E',
            }}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? (
              <>
                <span>收起</span>
                <CaretUpOutlined style={{ marginLeft: '8px' }} />
              </>
            ) : (
              <>
                <span>更多</span>
                <CaretDownOutlined style={{ marginLeft: '8px' }} />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
export default TagCheckBox
